import { toRelativeUrl } from '@okta/okta-auth-js';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context }) => {
    const { authClient } = context;

    if (!(await authClient.isAuthenticated())) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      await new Promise(() => authClient.signInWithRedirect({ originalUri }));
    }
  },
  component: Outlet,
});
